// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3KrhQ","notes":"Notes_notes__1cyQP","note":"Notes_note__2UdPp","markdown":"Notes_markdown__3_DHY"};